module.exports = __webpack_public_path__ + "static/media/ic_in_store_black.30e884ce.svg";